import { generatePath } from 'react-router-dom';

type RouteParamValue = string | number | undefined;

const normalizeRouteParams = (params: Record<string, RouteParamValue>) =>
  Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, String(value)]),
  );

export const Routes = {
  // Public
  authentication: {
    signIn: '/sign-in',
    logOut: '/log-out',
    oauthYandex: '/oauth/yandex',
    oauthGoogle: '/oauth/google',
    invite: '/invite/:token',
  },

  // Private
  profile: {
    organization: {
      root: '/profile/organization',
      organizationCreate: '/profile/organization/create',
      organizationDetails: '/profile/organization/:organizationId',
    },
    user: {
      root: '/profile/user',
      userUpdate: '/profile/user/update',
    },
  },

  analytics: {
    root: '/analytics',
  },

  dialogs: {
    root: '/dialogs',
    dialog: '/dialogs/dialog/:dialogId',
  },

  aiAgents: {
    root: '/ai-agents',
    create: '/ai-agents/create',
    agent: '/ai-agents/agent/:agentId',
  },

  channels: {
    root: '/channels',
    create: '/channels/create/:type',
    update: '/channels/:channelId',
    integrations: '/channels/:channelId/integrations',
  },

  presets: {
    root: '/presets',
    create: '/presets/create',
    preset: '/presets/:presetId',
  },

  knowledgeBase: {
    root: '/knowledge-base',
  },

  preview: {
    root: '/preview',
  },

  mailing: {
    root: '/mailing',
  },

  team: {
    root: '/team',
  },

  billing: {
    root: '/billing',
  },

  support: {
    root: '/support',
  },

  organizationScope: {
    root: '/organization/:organizationId',
    analytics: '/organization/:organizationId/analytics',
    dialogs: '/organization/:organizationId/dialogs',
    dialog: '/organization/:organizationId/dialogs/dialog/:dialogId',
    aiAgents: '/organization/:organizationId/ai-agents',
    aiAgentsCreate: '/organization/:organizationId/ai-agents/create',
    aiAgent: '/organization/:organizationId/ai-agents/agent/:agentId',
    channels: '/organization/:organizationId/channels',
    channelsCreate: '/organization/:organizationId/channels/create/:type',
    channelsUpdate: '/organization/:organizationId/channels/:channelId',
    channelsIntegrations: '/organization/:organizationId/channels/:channelId/integrations',
    presets: '/organization/:organizationId/presets',
    presetsCreate: '/organization/:organizationId/presets/create',
    preset: '/organization/:organizationId/presets/:presetId',
    knowledgeBase: '/organization/:organizationId/knowledge-base',
    preview: '/organization/:organizationId/preview',
    team: '/organization/:organizationId/team',
    billing: '/organization/:organizationId/billing',
    support: '/organization/:organizationId/support',
  },
};

export const buildOrganizationRoute = (
  path: string,
  organizationId: string | number,
  params: Record<string, RouteParamValue> = {},
) =>
  generatePath(
    path,
    normalizeRouteParams({
      organizationId,
      ...params,
    }),
  );
